import {RESET_STATE} from "../redux/Reset/reset";
import {useDispatch} from "react-redux";
import {logout} from "../redux/actions/authSlice";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

const AutoLogoutWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onLogout = async () => {
    const result = await dispatch(logout());
    dispatch({type: RESET_STATE});
    if (result.meta.requestStatus === "fulfilled") {
      navigate("/");
    }
  };

  function checkAndLogoutAtMidnight() {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);

    const timeUntilMidnight = midnight - now;
    const warningTime = 1 * 60 * 1000; // e.g., warn 1 minutes before logout

    // setTimeout(() => {
    //   toast.error("You will be logged out in 1 minutes.");
    // }, timeUntilMidnight - warningTime);
    setTimeout(() => {
      onLogout();
      checkAndLogoutAtMidnight();
    }, timeUntilMidnight);
  }

  function handleVisibilityChange() {
    if (!document.hidden) {
      checkAndLogoutAtMidnight();
    }
  }
  useEffect(() => {
    checkAndLogoutAtMidnight();
    // Optionally, add visibility change handling if needed
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup if you added event listeners
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch]);
  return null;
};

export default AutoLogoutWrapper;
